import * as tslib_1 from "tslib";
import { of } from 'rxjs';
var ContentService = /** @class */ (function () {
    function ContentService() {
    }
    return ContentService;
}());
export { ContentService };
var FakeContentService = /** @class */ (function (_super) {
    tslib_1.__extends(FakeContentService, _super);
    function FakeContentService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FakeContentService.prototype.getContent = function (key, lang, responseType) {
        return of({});
    };
    FakeContentService.prototype.setClient = function (clientName) { };
    return FakeContentService;
}(ContentService));
export { FakeContentService };
